import { render, staticRenderFns } from "./FundsTransferTab.vue?vue&type=template&id=70af7ab2&scoped=true&"
import script from "./FundsTransferTab.vue?vue&type=script&lang=js&"
export * from "./FundsTransferTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af7ab2",
  null
  
)

export default component.exports